export const PRODUCT = 'PRODUCT'
export const TEXT = 'TEXT'
export const IMAGE = 'IMAGE'
export const VIDEO = 'VIDEO'
export const TYPE_IMAGE = 1
export const TYPE_VIDEO = 3
export const STREAMING = 'STREAMING'
export const PLACEHOLDER = 'PLACEHOLDER'
